import { withRetry } from '@core/domain/utils/asyncResilience.ts';
import { isRetryableHttpTransportThrownFailure } from '@core/domain/utils/httpTransportFailure.ts';

const SYNC_FETCH_RETRY_OPTS = {
  maxAttempts: 5,
  baseDelayMs: 400,
  maxDelayMs: 5_000,
  jitterRatio: 0.2,
  isRetryable: isRetryableHttpTransportThrownFailure,
} as const;

/** Alias for {@link isRetryableHttpTransportThrownFailure}; retained for existing call sites/tests. */
export const isRetryableSyncFetchError = isRetryableHttpTransportThrownFailure;

/** Runs a sync POST/GET attempt with exponential backoff + jitter (see {@link SYNC_FETCH_RETRY_OPTS}). */
export function withSyncFetchRetry<T>(operation: () => Promise<T>): Promise<T> {
  return withRetry(operation, SYNC_FETCH_RETRY_OPTS);
}
